import { refreshGrant } from './keycloak-auth'

export type RefreshedSessionTokens = {
  accessToken: string
  refreshToken: string
}

type RefreshResponse = {
  accessToken?: string
  refreshToken?: string
}

type RefreshRequest = (refreshToken: string) => Promise<RefreshResponse>

export const canRefreshSession = (refreshToken: string | null) =>
  Boolean(refreshToken)

export const createSessionTokenRefresher = (request: RefreshRequest) => {
  const pendingRefreshes = new Map<string, Promise<RefreshedSessionTokens>>()

  return (refreshToken: string): Promise<RefreshedSessionTokens> => {
    const pendingRefresh = pendingRefreshes.get(refreshToken)

    if (pendingRefresh) {
      return pendingRefresh
    }

    const refresh = request(refreshToken)
      .then((response) => {
        if (!response.accessToken) {
          throw new Error('The session refresh response has no accessToken')
        }

        return {
          accessToken: response.accessToken,
          refreshToken: response.refreshToken || refreshToken,
        }
      })
      .finally(() => {
        pendingRefreshes.delete(refreshToken)
      })

    pendingRefreshes.set(refreshToken, refresh)

    return refresh
  }
}

export const refreshSessionToken = createSessionTokenRefresher(
  async (refreshToken) => {
    const tokens = await refreshGrant(refreshToken)

    return {
      accessToken: tokens.access_token,
      refreshToken: tokens.refresh_token,
    }
  }
)
